import { useLayoutEffect } from 'react';
import { Outlet, useMatches } from 'react-router';

import { Header } from '@widgets/header';
import { Sidebar } from '@widgets/sidebar';

import { useActions, usePageTitle } from '@shared/lib/hooks';

import s from './MainLayout.module.css';

export const MainLayout = () => {
	const matches = useMatches();
	const { setSessionMini } = useActions();

	const sidebarMini = matches.findLast((m) => m.handle?.sidebarMini !== undefined)?.handle?.sidebarMini ?? null;

	usePageTitle();

	useLayoutEffect(() => {
		setSessionMini(sidebarMini);
	}, [sidebarMini]);

	return (
		<div className={s.main_layout}>
			<Header className={s.main_layout_header} />

			<div className={s.main_layout_body}>
				<Sidebar className={s.main_layout_sidebar} />
				<main className='layout__content'>
					<Outlet />
				</main>
			</div>
		</div>
	);
};
